import { useHistory } from "react-router-dom";

import UnrollTweetForm from "./UnrollTweetForm";
import RecentThreads from "./RecentThreads";

/**
   Logic for Home Screen:

     - Input bar takes in a tweet id
     - Form submission calls getThreadByTweetId
       - Or, it might makes sense to call this something
         different. Like `compileThread`. And then that
         returns the thread id, and the home page uses
         that id to redirect to the permalink for the thread.
**/

function Home() {
  const history = useHistory();

  const unrollThreadCallback = (response) => {
    history.push(`/thread/${response.threadId}`);
  };

  return (
    <div className="min-h-screen p-6 flex flex-col items-center justify-start">
      <div className="w-11/12 sm:w-3/4 max-w-screen-md">
        <UnrollTweetForm
          placeholder="Enter the URL of any tweet from a thread"
          callback={unrollThreadCallback}
        />
      </div>

      <RecentThreads />
    </div>
  );
}

export default Home;
